import { createSlice } from '@reduxjs/toolkit';
import { Transaction, TransactionDetailsState } from 'types/transaction';
import { notify } from 'components/Common/Toast';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { ID } from 'types/common';

const transaction: Transaction = {
    confirmationCode: '',
    type: '',
    amount: 0,
    transactionStatus: '',
    sourceMoneyContainerSubtype: '',
    transactionDateTime: '',
    consumer: {
        firstName: '',
        lastName: '',
        name: '',
        username: '',
        imgUrl: '',
        playerId: null,
        uuid: '',
        blocked: false,
    },
    maxRefundAmount: 0,
    canBeCancelled: true,
    canBeRefunded: false,
    canRequestRefund: false,
};

const initialState: TransactionDetailsState = {
    details: transaction,
    loading: false,
    error: false,
};

/** Phase 12 — static Freeze: no legacy trxDetail. */
export const fetchTransactionDetails = createAsyncThunkWrapper<any, ID>('transactionDetails/fetchTransactionDetails', async (_id: ID) => {
    return { ...transaction };
});

export interface IssueRefundPayload {
    amount: number;
    svaFrom: string;
    currencyCode: string;
    companyCode: string;
    username: string;
}

export interface TransferFundsPayload {
    amount: number;
    companyCode: string;
    containerId: string;
    isM2MTransfer: boolean;
    subject?: string;
    currencyCode: string;
}

/** Phase 12 — static: no paymentM2M. */
export const transferFunds = createAsyncThunkWrapper<any, TransferFundsPayload>(
    'transaction/transferFunds',
    async (_trxDetails: TransferFundsPayload) => {
        notify('Transfers are unavailable until payments remount.', 'info');
        return { code: 0 };
    }
);

/** Phase 12 — static: no transferM2P. */
export const issueRefund = createAsyncThunkWrapper<any, IssueRefundPayload>(
    'transactionDetails/issueRefund',
    async (_data: IssueRefundPayload) => {
        notify('Refunds are unavailable until payments remount.', 'info');
        return { code: 0 };
    }
);

const transactionDetailsSlice = createSlice({
    name: 'parishionerTransactionDetail',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchTransactionDetails.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchTransactionDetails.fulfilled, (state, action) => {
            state.loading = false;
            if (!action.payload) return;
            state.details = action.payload || {};
        });
        builder.addCase(fetchTransactionDetails.rejected, (state) => {
            state.loading = false;
            state.details = initialState.details;
        });
    },
});

export default transactionDetailsSlice.reducer;
